export default "__VITE_PUBLIC_ASSET__a95ea6f0__"